import { createFileRoute } from "@tanstack/react-router"
import Account from "@/pages/account"

export const Route = createFileRoute("/$countryCode/account/")({
  head: () => ({
    meta: [
      { title: "Your account | +Bake Cafe" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: Account,
})
